import { useForm } from 'react-hook-form';
import { getSignUpFormFields } from './definition';
import { signupUser } from '../../../store/actions';
import { SignUpFormType } from './types';
import { useDispatch } from 'react-redux';

export const useSignUpForm = () => {
	const dispatch = useDispatch();
	const {
		register,
		watch,
		handleSubmit,
		formState: { errors },
		getValues
	} = useForm<SignUpFormType>({ mode: 'onChange' });

	const submit = () =>
		handleSubmit((data: SignUpFormType) => {
			const signupRequest = mapToSignupReq(data);
			console.debug('user data: \n' + JSON.stringify(data, null, 2));
			dispatch(signupUser(signupRequest));
		})();

	const mapToSignupReq = (data: SignUpFormType) => {
		return {
			firstName: data.firstName,
			lastName: data.lastName,
			email: data.email,
			company: data.company,
			password: data.password
		};
	};

	return {
		sections: getSignUpFormFields(register, errors, watch),
		actions: {
			submit: () => submit(),
			getValues
		}
	};
};
